function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "exampleGradient"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "10%",
  stopColor: "#007CC0",
  stopOpacity: 1
}), /*#__PURE__*/React.createElement("stop", {
  offset: "95%",
  stopColor: "#007CC0",
  stopOpacity: 0.2
})));

var _ref3 = /*#__PURE__*/React.createElement("animate", {
  id: "dash",
  attributeName: "stroke-dashoffset",
  values: "0;400",
  begin: "0s",
  dur: "3s",
  fill: "freeze",
  repeatCount: "indefinite"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M236.93,133.73c9.38-1.49,9.48-1.42,9.48,7q0,53,0,106a73.46,73.46,0,0,0,.4,8.65c1.42,12,10.39,19.76,22.32,19.51s21.24-9,21.53-21.13c.34-14.45.08-28.91.11-43.37.1-48.65,36.39-85,84.93-85,8.45,0,16.89,0,25.82,0v9.79c-2.33,0-4.91-.17-7.46,0-13.72,1-27.9.32-41,3.68-31.06,7.93-52.29,37.21-52.5,69.4-.09,14.66.06,29.33-.05,44-.13,19-13.24,32.42-31.51,32.55s-32.17-13.13-32.28-31.86c-.23-38.62-.08-77.24-.07-115.87C236.63,136,236.81,135,236.93,133.73Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M185,133.34H194c.11,2.66.31,5.06.31,7.46,0,36.31.09,72.62,0,108.93-.07,28.33,10.74,50.79,35,66.11,2.89,1.83,4.07,3.69,2,7.05s-4.26,3.58-7.54,1.46c-24-15.55-38-37.61-38.85-66-1.16-40.61-.33-81.28-.33-121.92A23.08,23.08,0,0,1,185,133.34Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M295.51,333.11c-1.3-3.33-2.34-6-3.57-9.09,2.66-1.31,5-2.51,7.36-3.63,28.05-13.29,42.48-35.65,43.53-66.5.51-14.64.05-29.32.11-44,.07-17.47,10.84-30.28,28-32,10-1,20.12-.18,30.62-.18v9.69H379c-18.45,0-26.12,7.83-26.32,26.33-.21,18.15,1.07,36.57-1.61,54.37C346.22,300.28,326.11,321,295.51,333.11Z"
});

var _ref7 = /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "translate",
  from: "0 0",
  to: "0 400",
  dur: "0.8s",
  begin: "0s",
  repeatCount: "indefinite",
  id: "drop1-anim"
});

var _ref8 = /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  from: 1,
  to: 0,
  dur: "0.8s",
  repeatCount: "indefinite",
  begin: "0s"
});

var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  fill: "url(#exampleGradient)",
  fillOpacity: 0.2,
  cx: 268,
  cy: 750,
  rx: 200,
  ry: 18.92
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "rx",
  from: 27,
  to: 200,
  dur: "1.8s",
  begin: "drop1-anim.begin +0.8s",
  repeatCount: "indefinite"
}));

var _ref10 = /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "translate",
  from: "-20 -50",
  to: "-20 300",
  dur: "0.5s",
  begin: "0s",
  repeatCount: "indefinite",
  id: "drop2-anim"
});

var _ref11 = /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  from: 1,
  to: 0,
  dur: "0.5s",
  repeatCount: "indefinite",
  begin: "0s"
});

var _ref12 = /*#__PURE__*/React.createElement("ellipse", {
  fill: "url(#exampleGradient)",
  fillOpacity: 0.2,
  cx: 298,
  cy: 750,
  rx: 300,
  ry: 18.92
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "rx",
  from: 27,
  to: 300,
  dur: "1.5s",
  begin: "drop2-anim.begin +0.5s",
  repeatCount: "indefinite"
}));

var SvgAnimatedLeak = function SvgAnimatedLeak(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    viewBox: "0 0 566.93 866.93",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, "1\r\n  ", /*#__PURE__*/React.createElement("g", {
    id: "RG6nfl",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00A9E4"
    },
    opacity: 1,
    d: "M 189.839 134.416 L 241.419 133.867 L 240.87 266.11 L 263.368 281.474 C 263.368 281.474 283.122 279.828 283.671 279.828 C 284.22 279.828 298.487 256.782 298.487 256.782 L 296.84 191.483 L 309.461 159.109 L 335.8 139.355 L 361.59 130.575 L 401.098 129.478 L 401.098 183.253 L 362.687 182.704 L 353.359 193.13 L 348.969 209.043 L 348.421 266.659 L 334.702 301.777 L 310.559 319.885 L 296.84 328.116 L 266.66 332.506 L 229.347 322.629 L 197.521 286.962 L 190.936 258.428"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    style: {
      strokeDasharray: "200,200",
      strokeDashoffset: 0,
      strokeWidth: 50,
      fill: "none",
      stroke: "#007CC0",
      strokeOpacity: 0.2
    },
    d: "M 400.174 157.23 C 400.174 157.23 363.734 158.31 356.642 160.721 C 349.839 163.035 343.263 168.144 338.678 171.617 L 336.113 174.259 C 322.251 187.599 323.52 200.16 322.68 213.43 C 322.5 232.824 323.796 250.436 321.271 264.742 L 321.239 265.007 C 321.176 265.395 320.197 271.767 312.185 288.05 L 312.157 288.107 L 312.116 288.155 C 306.448 294.716 299.369 298.597 287.107 303.291 L 287.075 303.303 L 287.042 303.311 C 283.202 304.21 278.895 305.611 266.534 304.309 C 256.393 303.376 250.01 302.324 246.145 301.49 C 244.222 301.074 239.397 298.743 239.397 298.743 L 239.367 298.731 C 230.515 295.073 217.77 279.123 214.926 257.629 L 214.923 257.604 L 214.922 257.578 L 214.921 257.536 L 214.92 257.476 C 213.816 219.545 214.228 191.619 214.458 162.725 C 214.466 161.707 214.818 136.275 214.826 135.255",
    transform: "matrix(1, 0, 0, 1, 2.632638, 0)"
  }, _ref3), _ref4, _ref5, _ref6, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007CC0"
    },
    id: "drop1",
    d: "M290.58,362c0,23.1-20.75,37.56-42.17,29.43-11.84-4.49-20.6-21.23-18.81-34.55,1.57-11.58,7.74-20.57,14.31-29.64,4.17-5.77,7.34-12.25,11.24-18.23,1.22-1.87,3.33-4.35,5-4.37s3.78,2.5,5,4.35c5.24,7.85,9.82,16.18,15.42,23.75C287.17,341.54,290.62,351.1,290.58,362Zm-30.11-40.35c-5.76,8-12,14.83-16,22.77-3,5.92-4.35,13.26-4.43,20-.12,11.13,6.93,18.1,17.09,19,12.17,1.06,20.7-4.36,23.3-15.42,1.67-7.14,1.78-14.58-2.31-21C272.71,338.52,266.66,330.48,260.47,321.64Z"
  }, _ref7, _ref8), _ref9, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00A9E4"
    },
    id: "drop2",
    d: "M329.05,416.59c-1.43,14.57-11.94,25.64-24.59,25-13.92-.72-23.68-12.34-21.31-26.77,1-6,4.12-11.85,7-17.41A137.15,137.15,0,0,1,300,381.81c1.31-1.87,3.44-4.32,5.25-4.36s3.84,2.47,5.14,4.32a171.72,171.72,0,0,1,11,17.07C324.44,404.49,326.54,410.65,329.05,416.59Zm-24.65-24.4c-4.43,8.65-9.17,15.48-11.46,23a12.68,12.68,0,0,0,11,16.17c7.5.5,12.5-5,13.33-13.67C318.29,407.2,310.45,401.62,304.4,392.19Z"
  }, _ref10, _ref11), _ref12));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAnimatedLeak, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/animated_leak.29cbafb4.svg";
export { ForwardRef as ReactComponent };